// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/********************************************************************************
 * Copyright (C) 2018 Red Hat, Inc. and others.
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License v. 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * This Source Code may also be made available under the following Secondary
 * Licenses when the conditions for such availability set forth in the Eclipse
 * Public License v. 2.0 are satisfied: GNU General Public License, version 2
 * with the GNU Classpath Exception which is available at
 * https://www.gnu.org/software/classpath/license.html.
 *
 * SPDX-License-Identifier: EPL-2.0 OR GPL-2.0-only WITH Classpath-exception-2.0
 ********************************************************************************/

.theia-plugins {
  min-width: 250px !important;
  display: flex;
  flex-direction: column;
}

#pluginListContainer {
  width: 100%;
  box-sizing: border-box;
  overflow-y: auto;
  flex-grow: 1;
}

.theia-plugins .pluginHeaderContainer {
  padding: 5px 15px;
  font-size: var(--theia-ui-font-size0);
}

.theia-side-panel .theia-plugins .pluginHeaderContainer {
  padding-left: 20px;
}

.theia-plugins .pluginHeaderContainer:hover {
  background: var(--theia-list-hoverBackground);
}

.theia-plugins .pluginHeaderContainer .row {
  margin: 3px 0;
}

.theia-plugins .pluginName {
  flex: 1;
  margin-right: 5px;
  margin-left: 4px;
  font-size: var(--theia-ui-font-size1);
  font-weight: 400;
}

.theia-plugins .pluginVersion {
  flex: 1;
  text-align: left;
  font-size: var(--theia-ui-font-size0);
}

.theia-plugins .pluginDescription {
  flex: 1;
}

.theia-plugins .pluginPublisher {
  font-size: var(--theia-ui-font-size0);
  flex: 5;
  align-items: center;
}

.plugins-tab-icon::before {
  content: "\\f0fe";
}
`, "",{"version":3,"sources":["webpack://./../../actions-runner/_work/arduino-ide/arduino-ide/node_modules/@theia/plugin-ext/src/main/browser/style/plugin-sidebar.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;iFAciF;;AAEjF;EACE,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,OAAO;EACP,iBAAiB;EACjB,gBAAgB;EAChB,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,qCAAqC;EACrC,OAAO;EACP,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":["/********************************************************************************\n * Copyright (C) 2018 Red Hat, Inc. and others.\n *\n * This program and the accompanying materials are made available under the\n * terms of the Eclipse Public License v. 2.0 which is available at\n * http://www.eclipse.org/legal/epl-2.0.\n *\n * This Source Code may also be made available under the following Secondary\n * Licenses when the conditions for such availability set forth in the Eclipse\n * Public License v. 2.0 are satisfied: GNU General Public License, version 2\n * with the GNU Classpath Exception which is available at\n * https://www.gnu.org/software/classpath/license.html.\n *\n * SPDX-License-Identifier: EPL-2.0 OR GPL-2.0-only WITH Classpath-exception-2.0\n ********************************************************************************/\n\n.theia-plugins {\n  min-width: 250px !important;\n  display: flex;\n  flex-direction: column;\n}\n\n#pluginListContainer {\n  width: 100%;\n  box-sizing: border-box;\n  overflow-y: auto;\n  flex-grow: 1;\n}\n\n.theia-plugins .pluginHeaderContainer {\n  padding: 5px 15px;\n  font-size: var(--theia-ui-font-size0);\n}\n\n.theia-side-panel .theia-plugins .pluginHeaderContainer {\n  padding-left: 20px;\n}\n\n.theia-plugins .pluginHeaderContainer:hover {\n  background: var(--theia-list-hoverBackground);\n}\n\n.theia-plugins .pluginHeaderContainer .row {\n  margin: 3px 0;\n}\n\n.theia-plugins .pluginName {\n  flex: 1;\n  margin-right: 5px;\n  margin-left: 4px;\n  font-size: var(--theia-ui-font-size1);\n  font-weight: 400;\n}\n\n.theia-plugins .pluginVersion {\n  flex: 1;\n  text-align: left;\n  font-size: var(--theia-ui-font-size0);\n}\n\n.theia-plugins .pluginDescription {\n  flex: 1;\n}\n\n.theia-plugins .pluginPublisher {\n  font-size: var(--theia-ui-font-size0);\n  flex: 5;\n  align-items: center;\n}\n\n.plugins-tab-icon::before {\n  content: \"\\f0fe\";\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
